import React, { useState } from "react"

import { PieChart } from "react-minimal-pie-chart"

function Caloric({ caloric, weight }) {
    const [selected, setSelected] = useState(undefined)

    const lineWidth = 60

    return (
        <section className="chart">
            <PieChart 
                className="caloricChart"
                data={[
                    { title: "Carbs", value: caloric?.percentCarbs, color: "#E38627" },
                    { title: "Protein", value: caloric?.percentProtein, color: "#C13C37" },
                    { title: "Fat", value: caloric?.percentFat, color: "#6A2135" },
                ]}
                lineWidth={lineWidth}
                radius={PieChart.defaultProps.radius - 6}
                segmentsStyle={{ transition: "stroke .3s", cursor: "pointer" }}
                segmentsShift={index => (index === selected ? 5 : 1)}
                animate
                label={({ dataEntry }) => Math.round(dataEntry.percentage) + "%"}
                labelPosition={100 - lineWidth / 2}
                labelStyle={{
                    fill: "#fff",
                    opacity: 0.75,
                    pointerEvents: "none",
                    fontSize: "7px",
                }}
                onClick={(_, index) => {
                    setSelected(index === selected ? undefined : index)
                }}
            />

            <div>
                <div className="caloric">
                    <div className="carb"></div>
                    <p>Carbs { (caloric?.percentCarbs * weight / 100).toFixed(2)}g</p>
                </div>
                <div className="caloric">
                    <div className="protein"></div>
                    <p>Protein { (caloric?.percentProtein * weight / 100).toFixed(2)}g</p>
                </div>
                <div className="caloric">
                    <div className="fat"></div>
                    <p>Fat { (caloric?.percentFat * weight / 100).toFixed(2)}g</p>
                </div>
            </div>
        </section>
        
    )
}

export default Caloric
